import { AxiosResponse } from 'axios';
import { API } from 'config';
import { LIST_BODY_RESULT, ResponseType } from 'models';
import {
  BASE_REQUEST_TYPE,
  BODY_ADD_SITTER,
  BODY_CHANGE_SITTER,
  BODY_EDIT_BASE_RAC,
  PURCHASE_HISTORY_ITEM_RESPONSE,
  PURCHASE_HISTORY_PARAMS_REQUEST,
  SITTER_AC_PARAMS_REQUEST,
  SUBSCRIPTION_DETAIL_TYPE,
  SUBSCRIPTION_PARAMS_REQUEST,
  SUBSCRIPTION_TYPE,
} from 'models/subscription';
import { AppAPIInstance } from 'services/config-api';

export const getSubscriptionListApi = async (
  params?: SUBSCRIPTION_PARAMS_REQUEST
): Promise<AxiosResponse<{ data: LIST_BODY_RESULT<SUBSCRIPTION_TYPE> }>> => {
  return await AppAPIInstance.get(API.SUBSCRIPTION.AC_BR_LIST, { params });
};

export const getSubscriptionDetailApi = async (
  id: string
): Promise<ResponseType<SUBSCRIPTION_DETAIL_TYPE>> => {
  return await AppAPIInstance.get(`${API.SUBSCRIPTION.DETAIL}/${id}`);
};

export const getBaseRequestDetailApi = async (
  id: string
): Promise<ResponseType<BASE_REQUEST_TYPE>> => {
  return await AppAPIInstance.get(`${API.SUBSCRIPTION.AC_BR}/${id}`);
};

export const updateBaseRequestDetailApi = async (
  id: string,
  data: BODY_EDIT_BASE_RAC
): Promise<ResponseType<BASE_REQUEST_TYPE>> => {
  return await AppAPIInstance.put(`${API.SUBSCRIPTION.AC_BR_LIST}/${id}`, data);
};

export const getSitterACListApi = async (
  params?: SITTER_AC_PARAMS_REQUEST
): Promise<AxiosResponse<any>> => {
  return await AppAPIInstance.get(API.SUBSCRIPTION.SITTER.DEFAULT, { params });
};

export const getListAcAcceptedSitterApi = async (
  params?: SITTER_AC_PARAMS_REQUEST
): Promise<AxiosResponse<any>> => {
  const { id, ...rest } = params || {};
  return await AppAPIInstance.get(API.SUBSCRIPTION.SITTER.ACCEPTED(id ?? ''), {
    params: rest,
  });
};

export const addSitterACApi = async (
  data: BODY_ADD_SITTER
): Promise<ResponseType<any>> => {
  return await AppAPIInstance.post(API.SUBSCRIPTION.SITTER.ADD, data);
};

export const changeSitterACApi = async (
  data: BODY_CHANGE_SITTER
): Promise<ResponseType<any>> => {
  return await AppAPIInstance.post(API.SUBSCRIPTION.SITTER.CHANGE, data);
};

export const acceptSitter = async (id:string): Promise<ResponseType<any>> => {
  return await AppAPIInstance.patch(
    API.SUBSCRIPTION.SITTER.ACCEPT(id),
    {
      status: 'accepted',
    }
  );
};

export const deleteSitterACApi = async (
  id: string
): Promise<ResponseType<any>> => {
  return await AppAPIInstance.delete(`${API.SUBSCRIPTION.SITTER.ADD}/${id}`);
};

export const getPurchaseHistoryApi = async (
  params?: PURCHASE_HISTORY_PARAMS_REQUEST
): Promise<
  AxiosResponse<{ data: LIST_BODY_RESULT<PURCHASE_HISTORY_ITEM_RESPONSE[]> }>
> => {
  return await AppAPIInstance.get(API.SUBSCRIPTION.PURCHASE_HISTORY, {
    params,
  });
};

export const getSubscriptionJoiningBySitterApi = async (
  sitter_id: string
): Promise<ResponseType<any>> => {
  return await AppAPIInstance.get(
    `${API.CONCIERGE.SUBSCRIPTION.SITTER.SITTER_JOINING}`,
    {
      params: {
        sitter_id,
      },
    }
  );
};

export const updateHourlyRatingSitterApi = async (
  data: { id: string; sitter_rate: number }[]
): Promise<ResponseType<any>> => {
  return await AppAPIInstance.patch(
    `${API.CONCIERGE.SUBSCRIPTION.SITTER.UPDATE_HOURLY_RATE}`,
    data
  );
};

export const importSubscriptionCSVApi = async (data: any) => {
  return await AppAPIInstance.post(
    `${API.CONCIERGE.SUBSCRIPTION.IMPORT_CSV}`,
    data
  );
};

export const updatePurchaseHistoryApi = async (
  id: string,
  data: { expiredAt: string | null }
): Promise<ResponseType<any>> => {
  return await AppAPIInstance.put(
    `${API.CONCIERGE.SUBSCRIPTION.PURCHASE_HISTORY.UPDATE(id)}`,
    data
  );
};
